import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-bd-scan-detail',
  templateUrl: './bd-scan-detail.component.html',
  styleUrls: ['./bd-scan-detail.component.css']
})
export class BdScanDetailComponent implements OnInit {
    batchDeliveryKeyno;

    purchInternalNo;

    purchLineKeyno;

    prodSizeColliKeyno;

    public quantityRestInColliesButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'purchhead', gotoParms: () => this.info!.purch_internal_no ?? '' }];

    public numberOfColliesButtons: FormButton[] = [
        {
            id: 'goto',
            type: 'primary',
            icon: 'fas fa-chevron-right',
            goto: 'batchdelreceivelines',
            gotoParms: () => ({
                batchdelivery_keyno: this.info!.batchdelivery_keyno,
                purch_internal_no: this.info!.purch_internal_no,
                purchline_keyno: this.info!.purchline_keyno,
                prodsizecolli_keyno: this.info!.prodsizecolli_keyno,
                stocklocation_keyno: '0',
                controlled: '1',
                placed: '0'
            })
        }
    ];

    public numberOfColliesPlacedButtons: FormButton[] = [
        {
            id: 'goto',
            type: 'primary',
            icon: 'fas fa-chevron-right',
            goto: 'batchdelreceivelines',
            gotoParms: () => ({
                batchdelivery_keyno: this.info!.batchdelivery_keyno,
                purch_internal_no: this.info!.purch_internal_no,
                purchline_keyno: this.info!.purchline_keyno,
                prodsizecolli_keyno: this.info!.prodsizecolli_keyno,
                stocklocation_keyno: '0',
                controlled: '0',
                placed: '1'
            })
        }
    ];

    public deliveredQuantityBeforeButtons: FormButton[] = [
        {
            id: 'goto',
            type: 'primary',
            icon: 'fas fa-chevron-right',
            goto: 'batchdeliveries',
            gotoParms: () => ({
                argtype: 'purch_internal_no',
                argvalue: this.info!.purch_internal_no
            })
        }
    ];

    public info?: Info;

    public itemsListPlaced: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.batchDeliveryKeyno = this.stateService.getStateParams()['batchdelivery_keyno'];
        this.purchInternalNo = this.stateService.getStateParams()['purch_internal_no'];
        this.purchLineKeyno = this.stateService.getStateParams()['purchline_keyno'];
        this.prodSizeColliKeyno = this.stateService.getStateParams()['prodsizecolli_keyno'];
    }

    private async loadInfo() {
        if (!!this.batchDeliveryKeyno && !!this.purchInternalNo && !!this.purchLineKeyno && !!this.prodSizeColliKeyno) {
            this.info = (await this.datatask.Post(1643, {
                batchdelivery_keyno: this.batchDeliveryKeyno,
                purch_internal_no: this.purchInternalNo,
                purchline_keyno: this.purchLineKeyno,
                prodsizecolli_keyno: this.prodSizeColliKeyno
            }))[0];
        }
    }

    private async loadPlaced() {
        if (!this.info) return;

        return this.itemsListPlaced = await this.datatask.Post(1644, this.info);
    }

    private async init() {
        await this.loadInfo();
        this.loadPlaced();
    }

    ngOnInit() {
        this.init();
    }
}

interface Info {
    batchdelivery_keyno: string;
    purch_internal_no: string;
    purchline_keyno: string;
    prodsizecolli_keyno: string;
    prod_name_long: string;
    colli_content: string;
    nbr_of_collies_received: string;
    ordered_quantity: string;
    delivered_quantity_before: string;
    quantity_rest: string;
    quantity_received: string;
    quantity_diff: string;
    quantity_rest_prodsizecolli: string;
    stock_quantity_information: string;
    colli_quantity_information: string;
    stockcolli_quantity_information: string;
    quantity_rest_in_collies: string;
    quantity_diff_in_collies: string;
    nbr_of_collies_placed: string;
    nbr_of_deviations: string;
}
